// modal.component.ts
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, UiButtonComponent],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})
export class ModalComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Titre du Modal';
  @Input() subtitle: string = '';
  @Input() icon: string = 'info';

  @Output() closeEvent = new EventEmitter<void>();

  close(): void {
    this.isVisible = false;
    this.closeEvent.emit();
  }

  onOverlayClick(event: MouseEvent): void {
    this.close();
  }
}